import { Component, AfterViewInit,ViewChild,ElementRef,Output, EventEmitter } from '@angular/core';
declare var $;


@Component({
  
 selector: 'dskl-wb-geometry-tools',
  templateUrl: 'geometry-tools.component.html',
  
})
export class GeometryToolsComponent implements AfterViewInit{
@Output() onTool = new EventEmitter();
      
clicked(w, r){
  this.onTool.emit({str: w, row: r});
  
}

ngAfterViewInit(){

		    
}
 }



// WEBPACK FOOTER //
// /app/src/app/wb/geometry/geometry-tools.component.ts